// Filters.js
import React from "react";
import {
  Box,
  Button,
  TextField,
  Modal,
  Typography,
  Switch,
  FormControlLabel,
} from "@mui/material";
import styles from "../../styles/SolicitacoesList.module.css";

const Filters = ({
  statusSelecionado,
  setStatusSelecionado,
  termoPesquisa,
  setTermoPesquisa,
  isDateFilterOpen,
  setIsDateFilterOpen,
  dataInicialTemp,
  setDataInicialTemp,
  dataFinalTemp,
  setDataFinalTemp,
  confirmarFiltroData,
  categoriaSelecionada,
  setCategoriaSelecionada,
  subcategorias,
  subcategoriasSelecionadas,
  setSubcategoriasSelecionadas,
  isFiltroPopupOpen,
  setIsFiltroPopupOpen,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        {/* Botões de Status */}
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", flex: 1 }}>
          {["PENDENTE", "ACEITO", "NEGADO"].map((status) => (
            <Button
              key={status}
              variant={statusSelecionado === status ? "contained" : "outlined"}
              onClick={() => setStatusSelecionado(status)}
            >
              {status}
            </Button>
          ))}
        </Box>

        {/* Campo de Busca */}
        <TextField
          fullWidth
          label="Buscar por nome, protocolo, serviço..."
          variant="outlined"
          value={termoPesquisa}
          onChange={(e) => setTermoPesquisa(e.target.value)}
          sx={{
            flex: 2,
            minWidth: "300px",
            "@media (max-width: 720px)": {
              flex: 1,
              minWidth: "100%",
            },
          }}
        />
      </Box>

      {/* Filtros Adicionais */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        {/* Filtro por Data */}
        <Button
          variant="outlined"
          onClick={() => setIsDateFilterOpen(true)}
          sx={{ flex: 1, "@media (max-width: 720px)": { width: "100%" } }}
        >
          Filtrar por Data
        </Button>

        {isDateFilterOpen && (
          <Modal
            open={isDateFilterOpen}
            onClose={() => setIsDateFilterOpen(false)}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: 2,
                p: 4,
                width: "90%",
                maxWidth: 400,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Filtrar por Data
              </Typography>

              {/* Atalhos de Data */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mb: 3,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const threeDaysAgo = new Date(today);
                    threeDaysAgo.setDate(today.getDate() - 3);
                    setDataInicialTemp(
                      threeDaysAgo.toISOString().split("T")[0]
                    );
                    setDataFinalTemp(today.toISOString().split("T")[0]);
                  }}
                >
                  Últimos 3 Dias
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const oneWeekAgo = new Date(today);
                    oneWeekAgo.setDate(today.getDate() - 7);
                    setDataInicialTemp(oneWeekAgo.toISOString().split("T")[0]);
                    setDataFinalTemp(today.toISOString().split("T")[0]);
                  }}
                >
                  Última Semana
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const today = new Date();
                    const firstDayOfLastMonth = new Date(
                      today.getFullYear(),
                      today.getMonth() - 1,
                      1
                    );
                    const lastDayOfLastMonth = new Date(
                      today.getFullYear(),
                      today.getMonth(),
                      0
                    );
                    setDataInicialTemp(
                      firstDayOfLastMonth.toISOString().split("T")[0]
                    );
                    setDataFinalTemp(
                      lastDayOfLastMonth.toISOString().split("T")[0]
                    );
                  }}
                >
                  Mês Passado
                </Button>
              </Box>

              {/* Campos de Data */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mb: 3,
                }}
              >
                <TextField
                  label="Data Inicial"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={dataInicialTemp}
                  onChange={(e) => setDataInicialTemp(e.target.value)}
                />
                <TextField
                  label="Data Final"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={dataFinalTemp}
                  onChange={(e) => setDataFinalTemp(e.target.value)}
                />
              </Box>

              {/* Botões de Ação */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  onClick={confirmarFiltroData}
                  sx={{ flex: 1 }}
                >
                  Aplicar
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => setIsDateFilterOpen(false)}
                  sx={{ flex: 1 }}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          </Modal>
        )}

        <Modal
          open={isDateFilterOpen}
          onClose={() => setIsDateFilterOpen(false)}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              boxShadow: 24,
              width: "90%",
              maxWidth: "400px",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Filtrar por Data
            </Typography>

            {/* Atalhos de Data */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  const today = new Date();
                  const threeDaysAgo = new Date(today);
                  threeDaysAgo.setDate(today.getDate() - 3);
                  setDataInicialTemp(threeDaysAgo.toISOString().split("T")[0]);
                  setDataFinalTemp(today.toISOString().split("T")[0]);
                }}
              >
                Últimos 3 Dias
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const today = new Date();
                  const oneWeekAgo = new Date(today);
                  oneWeekAgo.setDate(today.getDate() - 7);
                  setDataInicialTemp(oneWeekAgo.toISOString().split("T")[0]);
                  setDataFinalTemp(today.toISOString().split("T")[0]);
                }}
              >
                Última Semana
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const today = new Date();
                  const firstDayOfLastMonth = new Date(
                    today.getFullYear(),
                    today.getMonth() - 1,
                    1
                  );
                  const lastDayOfLastMonth = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    0
                  );
                  setDataInicialTemp(
                    firstDayOfLastMonth.toISOString().split("T")[0]
                  );
                  setDataFinalTemp(
                    lastDayOfLastMonth.toISOString().split("T")[0]
                  );
                }}
              >
                Mês Passado
              </Button>
            </Box>

            {/* Campos de Data */}
            <Box
              sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <TextField
                label="Data Inicial"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={dataInicialTemp}
                onChange={(e) => setDataInicialTemp(e.target.value)}
              />
              <TextField
                label="Data Final"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={dataFinalTemp}
                onChange={(e) => setDataFinalTemp(e.target.value)}
              />
            </Box>

            {/* Botões de Ação */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
            >
              <Button
                variant="contained"
                onClick={confirmarFiltroData}
                fullWidth
                sx={{ mr: 1 }}
              >
                Aplicar
              </Button>
              <Button
                variant="outlined"
                onClick={() => setIsDateFilterOpen(false)}
                fullWidth
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Filtro por Categoria */}
        <select
          className={styles.categoriaSelect}
          value={categoriaSelecionada}
          onChange={(e) => setCategoriaSelecionada(e.target.value)}
        >
          <option value="">Todas as Categorias</option>
          <option value="CONSULTA">Consulta</option>
          <option value="EXAME">Exame</option>
          <option value="TRANSPORTE">Transporte</option>
        </select>
      </Box>

      {/* Subcategorias (se aplicável) */}
      {categoriaSelecionada && subcategorias.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 2, // Margem inferior para separação do próximo elemento
              flexWrap: "wrap", // Para empilhar no mobile, se necessário
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ m: 0 }}>
              Filtrar Subcategorias
            </Typography>
            <Button
              variant="outlined"
              onClick={() => setIsFiltroPopupOpen(!isFiltroPopupOpen)}
              sx={{ whiteSpace: "nowrap" }}
            >
              Especialidades
            </Button>
          </Box>

          <Modal
            open={isFiltroPopupOpen}
            onClose={() => setIsFiltroPopupOpen(false)}
            aria-labelledby="modal-filtro-subcategorias"
            aria-describedby="modal-filtrar-subcategorias"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                p: 4,
                borderRadius: 2,
                boxShadow: 24,
                width: "90%",
                maxWidth: "400px",
              }}
            >
              <Typography
                id="modal-filtro-subcategorias"
                variant="h6"
                gutterBottom
              >
                Filtrar Subcategorias
              </Typography>

              {/* Botão para selecionar/desmarcar todas as opções */}
              <Button
                variant="outlined"
                fullWidth
                sx={{ mb: 2 }}
                onClick={() => {
                  if (
                    subcategoriasSelecionadas.length === subcategorias.length
                  ) {
                    setSubcategoriasSelecionadas([]); // Desmarca tudo
                  } else {
                    setSubcategoriasSelecionadas(subcategorias); // Marca tudo
                  }
                }}
              >
                {subcategoriasSelecionadas.length === subcategorias.length
                  ? "Desmarcar Tudo"
                  : "Selecionar Tudo"}
              </Button>

              {/* Lista de subcategorias com switches */}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {subcategorias.map((sub) => (
                  <FormControlLabel
                    key={sub}
                    control={
                      <Switch
                        checked={subcategoriasSelecionadas.includes(sub)}
                        onChange={() => {
                          if (subcategoriasSelecionadas.includes(sub)) {
                            setSubcategoriasSelecionadas((prev) =>
                              prev.filter((item) => item !== sub)
                            );
                          } else {
                            setSubcategoriasSelecionadas((prev) => [
                              ...prev,
                              sub,
                            ]);
                          }
                        }}
                      />
                    }
                    label={sub}
                    sx={{ flex: "1 0 45%" }}
                  />
                ))}
              </Box>

              {/* Botão para aplicar filtros */}
              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 3 }}
                onClick={() => setIsFiltroPopupOpen(false)}
              >
                Aplicar Filtros
              </Button>
            </Box>
          </Modal>
        </Box>
      )}
    </>
  );
};

export default Filters;
